import EditCreditCard from './EditCreditCard'

export default EditCreditCard
